import React, { useEffect, useState } from 'react';
import { useAIModelContext } from '../../../../context/ai-model.context';
import { useAIWorkflowContext } from '../../../../context/ai-workflow.context';
import { Handle } from '@xyflow/react';
import { AvailableNodes, NodeType, TemplateStatus } from '../../../../helper/constant';
import { renderNodeIcon } from '../../../../helper/helper';
import NodeStatus from '../components/NodeStatus';
import { NodeDeleteButton } from './InputNode';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import GenerativePrediction from '../components/GenerativePrediction';
import CustomLoader from '../../../common/CustomLoader';
import { getWorkflowExecutionResultAPI } from '../../../../service/ai-model.service';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const OutputNode = ({ data, id, setNodes, workflow }) => {
    const { showRightMenu, updateRightMenu } = useAIModelContext();
    const { updateSelecteNode, workflowExecution, workflowEdit } = useAIWorkflowContext();
    const [output, setOutput] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [generativeData, setGenerativeData] = useState(null);
    const [loading, setLoading] = useState(false);




    useEffect(() => {
        if (!showModal) {
            setGenerativeData(null);
        }
    }, [showModal]);



    const handleNodeClick = () => {
        updateRightMenu(true);
        updateSelecteNode({ id, data })
    };
    const renderNodeGenerative = () => {
        if (generativeData) {
            return (
                <GenerativePrediction
                    id={id}
                    name={'Output'}
                    executionId={workflowExecution.executionId}
                    data={generativeData}
                    showModal={showModal}
                    setShowModal={setShowModal} />
            )
        }
    }



    const onShowOutput = (e) => {
        e.stopPropagation();
        const payload = {
            "nodeId": id,
            "executionId": workflowExecution?.executionId
        }
        setLoading(true);
        getWorkflowExecutionResultAPI(payload)
            .then((res) => {
                if (res && res.length) {
                    const data = res[res.length - 1].data;
                    setGenerativeData(data);
                } else {
                    setGenerativeData(null)
                }
            }).catch((err) => setGenerativeData(null)
            ).finally(() => {
                setLoading(false)
                setShowModal(true);
            });
    }

    const renderNodeDetails = () => {
        if (data && data.prompt && workflowExecution && workflowExecution.executionId) {
            return (
                <div className='p-2 node-details text-align-center'>
                    {renderResultButton()}
                </div>
            )
        }
    }

    const renderResultButton = () => {
        const tooltipResult = (
            <Tooltip className='agent-tooltip'>
                Show Output
            </Tooltip>
        );
        return (<OverlayTrigger placement="top" overlay={tooltipResult}>
            <Link
                onClick={onShowOutput}
                className='align-self-center fs-10'>{<FontAwesomeIcon icon={faEye} />} View</Link>
        </OverlayTrigger>)
    }

    const renderDeleteButton = () => {
        if (workflowEdit)
            return <NodeDeleteButton id={id} />
    }

    const render = () => {
        if (data)
            return (
                <>
                    <div className={`dndnode d-flex flex-column gap-1 ${NodeType.OutputNode}`} onClick={handleNodeClick}>
                        {renderDeleteButton()}
                        {data &&
                            <div className='p-2 m-0 node-title d-flex justify-content-between align-items-center' style={{ backgroundColor: AvailableNodes[3].color }}>
                                <div className='d-flex align-items-center'>
                                    {renderNodeIcon(data.type, 25)}
                                    <p className='p-0 m-0'>{data.label}</p>
                                </div>
                                {workflow.status === TemplateStatus.COMPLETED && <NodeStatus id={id} name={workflow.name} />}
                            </div>
                        }
                        {renderNodeDetails()}
                        <Handle
                            type="target"
                            position="left"
                            style={{ background: '#555' }}
                            id={`${id}-target`}
                            isConnectable={true}
                        />
                    </div>
                    {renderNodeGenerative()}
                    {loading && <CustomLoader full />}
                </>
            )
    }
    return render();
}

export default OutputNode